import Axios from 'axios';
import { keepPreviousData, useQuery } from '@tanstack/vue-query';
import { ref } from 'vue';

export default function useSuggestQuery() {
  const term = ref('');

  const query = useQuery({
    queryKey: ['suggest', term],
    queryFn: () => Axios.get('/api/suggest', { params: { query: term.value } }),
    enabled: !!term.value,
    placeholderData: keepPreviousData,
  });

  return { query, term };
}
